"use strict";

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OtherCheckBox = exports.OtherInput = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.string.trim-start.js");

var _reactCheckboxGroup = require("react-checkbox-group");

var _radioCheckboxLabelHolder = _interopRequireWildcard(require("./labels/radioCheckboxLabelHolder"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./utils");

var _formElements = require("@evidation/form-elements");

var _commonComponents = require("../commonComponents");

var _lodash = _interopRequireDefault(require("lodash"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactI18next = require("react-i18next");

var _LanguageContext = require("../contexts/LanguageContext");

var _excluded = ["disabled", "displayLabel", "split", "withNone", "required", "displaySingleOptionLabel", "other"],
    _excluded2 = ["items", "input", "meta", "config", "labelStyle", "ComponentWrapper", "otherLabel", "t", "labelTooltip"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OtherInput = (0, _styledComponents["default"])(_formElements.TextInput).withConfig({
  displayName: "checkboxGroup__OtherInput"
})(["max-width:300px;"]);
exports.OtherInput = OtherInput;
var OtherCheckBox = (0, _styledComponents["default"])(_commonComponents.RadioCheckbox).withConfig({
  displayName: "checkboxGroup__OtherCheckBox"
})(["display:flex !important;flex-direction:column !important;align-items:baseline !important;"]);
exports.OtherCheckBox = OtherCheckBox;

var getSelectedValues = function getSelectedValues() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var initialValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var val = value || initialValues;

  if (!val) {
    return [];
  }

  if (_lodash["default"].isArray(val)) {
    return val;
  } else {
    return [val];
  }
};

var buildUniqueId = function buildUniqueId(name, label, value) {
  return "t-".concat(name ? name.replace(/\s/g, '') : _lodash["default"].snakeCase(label), "_").concat(_lodash["default"].snakeCase("".concat(value)));
};

var defaultOtherState = {
  otherChecked: false,
  otherValue: ''
};

var CheckboxGroup = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(CheckboxGroup, _PureComponent);

  var _super = _createSuper(CheckboxGroup);

  function CheckboxGroup(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckboxGroup);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOptionsAndValues", function () {
      var _this$props2;

      var _this$props = _this.props,
          value = _this$props.input.value,
          _this$props$config = _this$props.config,
          withNone = _this$props$config.withNone,
          noneLabel = _this$props$config.noneLabel,
          opts = _this$props$config.options,
          t = _this$props.t;
      var noneAbove = t('components.checkboxGroup.noneAbove');
      var checkboxOptions = withNone ? [].concat((0, _toConsumableArray2["default"])(opts), [{
        label: noneLabel ? noneLabel : noneAbove,
        answer: 'none'
      }]) : opts;
      var options = (0, _utils.checkboxOptionNormalization)(checkboxOptions);
      var selectedValues = getSelectedValues(value, (_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.initialValues);
      return {
        options: options,
        selectedValues: selectedValues
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "doNoneSelectedLogic", function (newSelectedValues) {
      if (_lodash["default"].includes(newSelectedValues, 'none')) {
        if (_lodash["default"].includes(_this.state.selectedValues, 'none')) {
          return _lodash["default"].without(newSelectedValues, 'none');
        } else {
          _this.setState(defaultOtherState);

          return ['none'];
        }
      }

      return newSelectedValues;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOnChange", function (newSelectedValues) {
      var selectedValues = _this.doNoneSelectedLogic(newSelectedValues); // always an array


      _this.setState({
        selectedValues: selectedValues
      }, _this.onChange);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function () {
      var _this$state = _this.state,
          selectedValues = _this$state.selectedValues,
          otherValue = _this$state.otherValue; // this component sends a single value as an array
      // so we just check for 1 result, in the original options,
      // and use the index 0

      var newVals = _this.state.options.length === 1 ? selectedValues[0] || '' : _lodash["default"].compact([].concat((0, _toConsumableArray2["default"])(selectedValues), [otherValue]));

      _this.props.input.onChange(newVals);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusOther", function () {
      _this.otherInput.current.focus();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOtherChecked", function (e) {
      if (e.target.checked) {
        _this.setState({
          otherChecked: true
        }, _this.focusOther);
      } else {
        var selectedValues = _lodash["default"].without(_this.state.selectedValues, _this.state.otherValue);

        _this.setState(_objectSpread({
          selectedValues: selectedValues
        }, defaultOtherState));
      }
    });
    _this.otherInput = /*#__PURE__*/_react["default"].createRef();

    var _this$getOptionsAndVa = _this.getOptionsAndValues(),
        _options = _this$getOptionsAndVa.options,
        _selectedValues = _this$getOptionsAndVa.selectedValues;

    _this.state = _objectSpread({
      selectedValues: _selectedValues,
      options: _options
    }, defaultOtherState);
    return _this;
  }

  (0, _createClass2["default"])(CheckboxGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevValues = getSelectedValues(prevProps.input.value);
      var newValues = getSelectedValues(this.props.input.value);

      if (_lodash["default"].difference(newValues, prevValues).length > 0) {
        this.setState({
          selectedValues: newValues
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectedValues = this.state.selectedValues;
      var _this$props3 = this.props,
          items = _this$props3.items,
          input = _this$props3.input,
          meta = _this$props3.meta,
          _this$props3$config = _this$props3.config,
          _this$props3$config$d = _this$props3$config.disabled,
          disabled = _this$props3$config$d === void 0 ? false : _this$props3$config$d,
          _this$props3$config$d2 = _this$props3$config.displayLabel,
          displayLabel = _this$props3$config$d2 === void 0 ? true : _this$props3$config$d2,
          _this$props3$config$s = _this$props3$config.split,
          split = _this$props3$config$s === void 0 ? false : _this$props3$config$s,
          withNone = _this$props3$config.withNone,
          _this$props3$config$r = _this$props3$config.required,
          required = _this$props3$config$r === void 0 ? false : _this$props3$config$r,
          _this$props3$config$d3 = _this$props3$config.displaySingleOptionLabel,
          displaySingleOptionLabel = _this$props3$config$d3 === void 0 ? false : _this$props3$config$d3,
          other = _this$props3$config.other,
          config = (0, _objectWithoutProperties2["default"])(_this$props3$config, _excluded),
          labelStyle = _this$props3.labelStyle,
          ComponentWrapper = _this$props3.ComponentWrapper,
          otherLabel = _this$props3.otherLabel,
          t = _this$props3.t,
          labelTooltip = _this$props3.labelTooltip,
          rest = (0, _objectWithoutProperties2["default"])(_this$props3, _excluded2);
      var otherText = otherLabel !== null && otherLabel !== void 0 ? otherLabel : t('common.other');

      var otherValue = _lodash["default"].lowerCase(otherText);

      var _this$getOptionsAndVa2 = this.getOptionsAndValues(),
          options = _this$getOptionsAndVa2.options;

      var onlyOneOption = options.length === 1; // By default, if there is only one option available, we only show the
      // checkbox with the label of the input, skipping the option label entirely.
      // You can disable this behavior by passing `true` to
      // `config.displaySingleOptionLabel`.

      var onlyDisplayPrimaryLabel = !displaySingleOptionLabel && onlyOneOption;

      var Inputs = _lodash["default"].map(options, function (item, i) {
        var _alwaysGetKeyValue = (0, _utils.alwaysGetKeyValue)(item),
            label = _alwaysGetKeyValue.label,
            value = _alwaysGetKeyValue.value;

        var unique_id = buildUniqueId(config.name, label, value);

        var output = /*#__PURE__*/_react["default"].createElement(_commonComponents.RadioCheckbox, {
          split: split,
          options: options,
          key: "".concat(unique_id, "_").concat(i)
        }, displayLabel || onlyOneOption ? /*#__PURE__*/_react["default"].createElement(_radioCheckboxLabelHolder["default"], {
          label: onlyDisplayPrimaryLabel ? rest.label : label,
          labelStyle: labelStyle,
          labelFor: unique_id
        }, /*#__PURE__*/_react["default"].createElement(_reactCheckboxGroup.Checkbox, {
          id: unique_id,
          value: value,
          disabled: disabled
        })) : /*#__PURE__*/_react["default"].createElement(_reactCheckboxGroup.Checkbox, {
          id: unique_id,
          value: value,
          disabled: disabled
        }));

        if (ComponentWrapper) {
          return /*#__PURE__*/_react["default"].createElement(ComponentWrapper, {
            "interface": "checkbox",
            nested: true,
            name: "".concat(config.name, ".").concat(i),
            key: "".concat(unique_id, "_").concat(i),
            index: i
          }, output);
        }

        return output;
      }); // checkboxDepth is checking for depth of elements
      // this is a requirement of the checkbox-group component
      // it helps with rendering speed.


      return /*#__PURE__*/_react["default"].createElement(_reactCheckboxGroup.CheckboxGroup, {
        checkboxDepth: ComponentWrapper ? 6 : 5,
        className: "checkboxgroup ".concat((0, _utils.constructFieldClassname)(meta)),
        name: input.name,
        value: selectedValues,
        onChange: this.handleOnChange
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, displayLabel && !(onlyOneOption && onlyDisplayPrimaryLabel) && /*#__PURE__*/_react["default"].createElement(_radioCheckboxLabelHolder.QuestionLabelHolder, null, /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        required: required,
        label: "".concat(rest.label),
        labelStyle: labelStyle,
        labelTooltip: labelTooltip
      })), /*#__PURE__*/_react["default"].createElement(_commonComponents.GroupListHolder, {
        allowResponsiveLabel: false
      }, Inputs, other && /*#__PURE__*/_react["default"].createElement(OtherCheckBox, {
        split: split,
        options: options,
        key: "".concat(buildUniqueId(config.name, rest.label, otherValue), "_").concat(Inputs.length)
      }, /*#__PURE__*/_react["default"].createElement(_radioCheckboxLabelHolder["default"], {
        label: otherText,
        labelStyle: labelStyle,
        labelFor: buildUniqueId(config.name, rest.label, otherValue)
      }, /*#__PURE__*/_react["default"].createElement(_reactCheckboxGroup.Checkbox, {
        id: buildUniqueId(config.name, rest.label, otherValue),
        value: "other",
        disabled: disabled,
        onClick: this.handleOtherChecked
      })), /*#__PURE__*/_react["default"].createElement(OtherInput, {
        "data-test": "other",
        onChange: function onChange(e) {
          var value = e.target.value.trimLeft();
          var otherChecked = !_lodash["default"].isEmpty(value);
          var selectedValues = otherChecked ? _lodash["default"].uniq([].concat((0, _toConsumableArray2["default"])(_this2.state.selectedValues), [otherValue])) : _lodash["default"].without(_this2.state.selectedValues, otherValue);

          _this2.setState({
            otherValue: value,
            selectedValues: selectedValues
          }, _this2.onChange);
        },
        onClick: function onClick() {
          _this2.handleOnChange(_lodash["default"].uniq([].concat((0, _toConsumableArray2["default"])(_this2.state.selectedValues), [otherValue])));
        },
        onBlur: function onBlur(e) {
          return input.onBlur();
        },
        disabled: disabled,
        value: this.state.otherValue,
        required: this.state.otherChecked,
        ref: this.otherInput
      })))));
    }
  }]);
  return CheckboxGroup;
}(_react.PureComponent);

CheckboxGroup.defaultProps = {
  ComponentWrapper: false,
  withNone: false,
  selectedValues: []
};

var _default = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(CheckboxGroup);

exports["default"] = _default;